import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import Scroll from "./scroll"
import Popup from "./popup"
import { PageTransition } from "./pageTransition"

import "../scss/site.scss"

const Layout = ({ children, isPress = false, removeFooterTopPadding = false }) => {
	const data = useStaticQuery(graphql`
		query SiteTitleQuery {
			site {
				siteMetadata {
					title
				}
			}
		}
	`)

	useEffect(() => {
		setTimeout(function () {
			document.body.classList.add("active")
		}, 500)
	})

	return (
		<>
			<Header isPress={isPress} siteTitle={data.site.siteMetadata?.title || `Title`} />
			<Scroll />
			<Popup />
			<PageTransition>
				<main className={`${isPress ? "press" : ""}`}>
					{children}
					<Footer removeFooterTopPadding={removeFooterTopPadding} />
				</main>
			</PageTransition>
		</>
	)
}

export default Layout
